import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AsyncDataService } from '../../services/async-data.service';
import { DateAgoPipe } from '../../pipes/date-ago.pipe';

@Component({
  selector: 'app-dg-notifypop',
  templateUrl: './dg-notifypop.component.html',
  styleUrls: ['./dg-notifypop.component.scss'],
})
export class DgNotifypopComponent implements OnInit {
  input: any;
  array = [];
  notificationList = [];
  notificationDate = [];
  myDate = new Date();
  show = false;

  profileAttachTitle = '';
  isProfileComponent = true; //flag to indetify profile Attachment Component
  profileAcceptedType = ['png', 'jpeg', 'jpg'];
  profileMaxSize = 5000000;
  profileUniqueAttachID = 'User Profile';
  isAllowFileToAttachProfile = false;
  profileAttachID = ''; //130573304
  empPhotoAttachId = null;
  isAllowDelete = false;

  constructor(
    private router: Router,
    private http: HttpClient,
    private dateAgoPipe: DateAgoPipe,
    private asyncDataService: AsyncDataService
  ) {
    this.asyncDataService.getNotificationFlag().subscribe((value) => {
      if (value) {
        this.fetchData();
      }
    });
  }

  empIds = [100007485, 100007483, 100007489, 100007487];
  imageList = [];
  ngOnInit(): void {
    this.fetchData();
  }

  fetchData(): void {
    this.imageList = [];
    this.input = {
      GRIDFILTERVO: [],
      orderBy: '',
      orderType: '',
      rowsPerPage: '20',
      startIndex: '1',
    };
    this.http
      .post(`/worklist/initmation-list`, this.input)
      .subscribe((res: any) => {
        const resData = res['data'];
        console.log('data from api', resData);
        const unreadArray = [];
        const readArray = [];
        resData.OutputEntity.forEach((item: any) => {
          const json = {};
          // item ?.attributeList.forEach((attr: any,index) => {

          //   if (attr.attrName === 'description') {
          //     json['desc'] = attr ?.attrValue
          //       }
          //       if(index % 2==0){
          //         json['new']=true
          //       }
          // });

          item?.attributeList.forEach((attr: any, index) => {
            if (attr.attrName === 'sentFromOrToName') {
              json['desc'] = attr?.attrValue;
            }
            if (attr.attrName === 'description') {
              json['description'] = attr?.attrValue;
            }
            // fetch data for calling
            if (attr.attrName === 'appTypeId') {
              json['appTypeId'] = attr?.attrValue;
            }
            if (attr.attrName === 'docId') {
              json['docId'] = attr?.attrValue;
            }

            if (attr.attrName === 'docNo') {
              json['docNo'] = attr?.attrValue;
            }

            if (attr.attrName === 'jobId') {
              json['jobId'] = attr?.attrValue;
            }

            if (attr.attrName === 'jobMvmntPk') {
              json['jobMvmntPk'] = attr?.attrValue;
            }

            if (attr.attrName === 'menuId') {
              json['menuId'] = attr?.attrValue;
            }

            if (attr.attrName === 'subject') {
              json['subject'] = attr?.attrValue;
            }

            if (attr.attrName === 'subjectId') {
              json['subjectId'] = attr?.attrValue;
            }
            // dta for call end

            if (attr.attrName === 'sentOrRcvdDate') {
              json['time'] = this.dateAgoPipe.transform(attr?.attrValue);
            }
            if (attr.attrName === 'readFlag') {
              if (attr?.attrValue === '0') {
                json['read'] = true;
              } else if (attr?.attrValue === '1') {
                json['read'] = false;
              }
            }

            if (attr.attrName === 'attachId') {
              json['attachId'] = Number(attr?.attrValue);
            }
          });

          if (json['read']) {
            // readArray.push(json);
          } else {
            unreadArray.push(json);
          }
        });
        this.notificationList = unreadArray.concat(readArray);
        if (this.notificationList.length !== 0) {
          this.show = true;
        }
        this.notificationList = this.notificationList.slice(0, 10);
        this.notificationList = [...this.notificationList];

        console.log('NotificationList', this.notificationList);
      });
  }
  goToIntimations(): void {
    void this.router.navigateByUrl('main/notifications');
  }

  onClick(notification) {
    console.log('notificaton print:::', notification);
    this.router.navigate(['main/notifications'], {
      state: { data: notification },
    });
  }

  getEmpPhotoAttachId(n): any {
    let a = -1;
    if (n?.desc?.toString()?.toLowerCase()?.trim()?.indexOf('rakesh') > -1) {
      a = this.imageList?.findIndex((x) => x.empId.toString() === '100007485');
      //console.log('attach index', a);
    } else if (
      n?.desc?.toString()?.toLowerCase()?.trim()?.indexOf('jitesh') > -1
    ) {
      a = this.imageList?.findIndex((x) => x.empId.toString() === '100007483');
      //console.log('attach index', a);
    } else if (
      n?.desc?.toString()?.toLowerCase()?.trim()?.indexOf('neeraj') > -1
    ) {
      a = this.imageList?.findIndex((x) => x.empId.toString() === '100007487');
      //.log('attach index', a);
    } else if (
      n?.desc?.toString()?.toLowerCase()?.trim()?.indexOf('bhatla') > -1
    ) {
      a = this.imageList?.findIndex((x) => x.empId.toString() === '100007489');
      //console.log('attach index', a);
    }
    if (a > -1) {
      return this.imageList[a]?.attachId;
    }
    return null;
  }
}
